import { firebase_Db } from "../../src/config/firebaseConfig";

const DBName = "errands";
const DBerrands = "deliverederrands";

// const UpdateMessages = async (id, title, duration) => {
//     return await firebase_Db.collection(DBName).doc(id).update({
//         title: title,
//         duration: duration,
//     });
// }

const deleteErrands = async (id) => {
  return await firebase_Db.collection(DBName).doc(id).delete();
};

const getErrands = async () => {
  return await firebase_Db
    .collection(DBName)
    .orderBy("dateCreated", "desc")
    .get();
};

const getDeliveredErrands = async () => {
  return await firebase_Db
    .collection(DBerrands)
    .orderBy("dateCreated", "desc")
    .get();
};

const adddeliveredErrands = async ({
  user,
  err_title,
  err_desc,

  delivered = true,
}) => {
  const ref = firebase_Db.collection(DBerrands).doc();
  return await firebase_Db.collection(DBerrands).add({
    id: ref.id,
    title: err_title,
    desc: err_desc,
    user: user,
    delivered: delivered,
  });
};

export { deleteErrands, getErrands, getDeliveredErrands, adddeliveredErrands };
